<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import {
		storeBuilderPreview,
		storeShowTools,
		storeElementID,
		storeData,
		storeContact,
	} from '../library/scripts/Store.svelte'
	import { styles } from '../library/scripts/styles'
	import { validate } from '../library/scripts/validate'
	import { send_mail } from '../builder/builderUtils'
	import * as animateScroll from 'svelte-scrollto'
	import Map from '../library/google_map/Map.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Alert from '../modals/Alert.svelte'
	import ContactMailList from '../components/ContactMailList.svelte'
	import IntersectionObserver from 'svelte-intersection-observer'

	//on devices with a height < 800 we do not set the observer
	let windowHeight = window.innerHeight

	const globals = getContext('globals')
	const fsS = globals.fsS
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover

	const winLocation = window.location.toString()

	if (winLocation.indexOf('preview') > -1) storeContact.set(false)

	//observer
	let element
	const set_observer = (e) => {
		if (e === 'set' && windowHeight > 600) {
			element.style.filter = 'blur(5px)'
		} else if (e !== 'set' && windowHeight > 600) {
			element.style.filter = 'blur(0px)'
		}
	}

	//error handling
	let error = false
	let errorMessage = null

	//send message
	let sendMessage = false
	let showSpinner = false
	let showResponse = false

	let elementID

	let configFile
	let contactBlock
	let inputFontColor
	let inputFontSize
	let inputFontFamily
	let inputBorder
	let inputBg
	let inputShadowX
	let inputShadowY
	let inputShadowBlur
	let inputShadowColor
	let inputFocus
	let infoContactColor
	let infoContactFontSize
	let infoContactFontFamily
	let infoLeftPadding
	let infoAddressColor
	let infoAddressFontFamily
	let infoAddressFontSize
	let infoAddressWeight
	let infoAddressStyle
	let infoAddressMarginBottom
	let infoNameColor
	let infoNameFontSize
	let infoNameWeight
	let infoNameFontFamily
	let infoNameStyle
	let infoNameDeco
	let infoNameMarginBottom
	let infoLeftBgColor
	let shadowX
	let shadowY
	let shadowBlur
	let shadowColor
	let containerLeftBg
	let containerLeftPaddingTop
	let containerLeftPaddingBottom
	let containerRightBg
	let titleAlign
	let titleValign
	let titleColor
	let titleBackgroundColor
	let titleFontFamily
	let titleFontSize
	let titleFontStyle
	let titleFontWeight
	let titleFontDeco
	let titleMT
	let titleMB
	let titleHeight
	let titlePadding
	let titleShadowX
	let titleShadowY
	let titleShadowBlur
	let titleShadowColor
	let height
	let padding
	let marginTop
	let marginBottom
	let buttonBg
	let buttonHover
	let buttonFontHover
	let buttonFontColor
	let buttonFontFamily
	let buttonFontSize
	let buttonBorderWidth
	let buttonBorderColor
	let buttonBorderRadius
	let buttonText
	let infoContactLeftColor
	let infoContactLeftStyle
	let infoContactLeftWeight
	let infoContactRightColor
	let infoContactRightStyle
	let infoContactRightWeight
	let mapHeight
	let mapWidth
	let mapBgColor
	let mapBorderColor
	let mapBorderStyle
	let mapBorderWidth
	let mapShadowColor
	let mapShadowX
	let mapShadowY
	let mapShadowBlur
	let borderBottomRadius
	let borderLeftWidth
	let borderLeftStyle
	let borderLeftColor
	let borderTopWidth
	let borderTopStyle
	let borderTopColor
	let borderRightWidth
	let borderRightStyle
	let borderRightColor
	let borderBottomWidth
	let borderBottomStyle
	let borderBottomColor
	let borderTopRadius

	const stoData = storeData.subscribe((value) => {
		if (value) {
			value.blocks.forEach((block) => {
				if (block.blockName === 'contact') {
					contactBlock = block
					borderTopRadius = contactBlock.borderTopRadius + 'px'
					borderBottomRadius = contactBlock.borderBottomRadius + 'px'
					borderLeftWidth = contactBlock.borderLeftWidth + 'px'
					borderLeftStyle = contactBlock.borderLeftStyle
					borderLeftColor = contactBlock.borderLeftColor
					borderTopWidth = contactBlock.borderTopWidth + 'px'
					borderTopStyle = contactBlock.borderTopStyle
					borderTopColor = contactBlock.borderTopColor
					borderRightWidth = contactBlock.borderRightWidth + 'px'
					borderRightStyle = contactBlock.borderRightStyle
					borderRightColor = contactBlock.borderRightColor
					borderBottomWidth = contactBlock.borderBottomWidth + 'px'
					borderBottomStyle = contactBlock.borderBottomStyle
					borderBottomColor = contactBlock.borderBottomColor
					inputFontColor = contactBlock.inputFontColor
					inputFontFamily = contactBlock.inputFontFamily
					inputFontSize = contactBlock.inputFontSize
					inputBorder = contactBlock.inputBorder
					inputBg = contactBlock.inputBg
					inputFocus = contactBlock.inputFocus
					inputShadowX = contactBlock.inputShadowX + 'px'
					inputShadowY = contactBlock.inputShadowY + 'px'
					inputShadowBlur = contactBlock.inputShadowBlur + 'px'
					inputShadowColor = contactBlock.inputShadowColor
					infoContactColor = contactBlock.infoContactColor
					infoContactFontSize = contactBlock.infoContactFontSize
					infoContactFontFamily = contactBlock.infoContactFontFamily
					infoLeftPadding = contactBlock.infoLeftPadding + '%'
					infoAddressColor = contactBlock.infoAddressColor
					infoAddressFontSize = contactBlock.infoAddressFontSize
					infoAddressFontFamily = contactBlock.infoAddressFontFamily
					infoAddressWeight = contactBlock.infoAddressWeight
					infoAddressStyle = contactBlock.infoAddressStyle
					infoAddressMarginBottom = contactBlock.infoAddressMarginBottom + '%'
					infoNameColor = contactBlock.infoNameColor
					infoNameFontSize = contactBlock.infoNameFontSize
					infoNameWeight = contactBlock.infoNameWeight
					infoNameFontFamily = contactBlock.infoNameFontFamily
					infoNameStyle = contactBlock.infoNameStyle
					infoNameDeco = contactBlock.infoNameDeco
					infoNameMarginBottom = contactBlock.infoNameMarginBottom + '%'
					infoLeftBgColor = contactBlock.infoLeftBgColor
					shadowX = contactBlock.shadowX + 'px'
					shadowY = contactBlock.shadowY + 'px'
					shadowBlur = contactBlock.shadowBlur + 'px'
					shadowColor = contactBlock.shadowColor
					containerLeftBg = contactBlock.containerLeftBg
					containerLeftPaddingTop = contactBlock.containerLeftPaddingTop + '%'
					containerLeftPaddingBottom = contactBlock.containerLeftPaddingBottom + '%'
					containerRightBg = contactBlock.containerRightBg
					titleAlign = contactBlock.titleAlign
					titleValign = contactBlock.titleValign
					titleColor = contactBlock.titleColor
					titleBackgroundColor = contactBlock.titleBackgroundColor
					titleFontFamily = contactBlock.titleFontFamily
					titleFontSize = contactBlock.titleFontSize
					titleFontStyle = contactBlock.titleFontStyle
					titleFontWeight = contactBlock.titleFontWeight
					titleFontDeco = contactBlock.titleFontDeco
					titleMT = contactBlock.titleMT + '%'
					titleMB = contactBlock.titleMB + '%'
					titleHeight = contactBlock.titleHeight + 'px'
					titlePadding = contactBlock.titlePadding + '%'
					titleShadowX = contactBlock.titleShadowX + 'px'
					titleShadowY = contactBlock.titleShadowY + 'px'
					titleShadowBlur = contactBlock.titleShadowBlur + 'px'
					titleShadowColor = contactBlock.titleShadowColor
					contactBlock.height = contactBlock.height
					padding = contactBlock.padding + '%'
					marginTop = contactBlock.marginTop + '%'
					marginBottom = contactBlock.marginBottom + '%'
					buttonBg = contactBlock.buttonBg
					buttonHover = contactBlock.buttonHover
					buttonFontHover = contactBlock.buttonFontHover
					buttonFontColor = contactBlock.buttonFontColor
					buttonFontFamily = contactBlock.buttonFontFamily
					buttonFontSize = contactBlock.buttonFontSize
					buttonBorderWidth = contactBlock.buttonBorderWidth + 'px'
					buttonBorderColor = contactBlock.buttonBorderColor
					buttonBorderRadius = contactBlock.buttonBorderRadius + 'px'
					buttonText = contactBlock.buttonText
					infoContactLeftColor = contactBlock.infoContactLeftColor
					infoContactLeftStyle = contactBlock.infoContactLeftStyle
					infoContactLeftWeight = contactBlock.infoContactLeftWeight
					infoContactRightColor = contactBlock.infoContactRightColor
					infoContactRightStyle = contactBlock.infoContactRightStyle
					infoContactRightWeight = contactBlock.infoContactRightWeight
					mapHeight = contactBlock.mapHeight + '%'
					mapWidth = contactBlock.mapWidth + '%'
					mapBgColor = contactBlock.mapBackgroundColor
					mapBorderColor = contactBlock.mapBorderColor
					mapBorderStyle = contactBlock.mapBorderStyle
					mapBorderWidth = contactBlock.mapBorderWidth + 'px'
					mapShadowColor = contactBlock.mapShadowColor
					mapShadowX = contactBlock.mapShadowX + 'px'
					mapShadowY = contactBlock.mapShadowY + 'px'
					mapShadowBlur = contactBlock.mapShadowBlur + 'px'
				}
			})
			configFile = value
		}
	})

	let showPreview
	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})

	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
		storeContact.set(true)
		animateScroll.scrollTo({ element: '#contact_title' })
	}

	const send_form = async () => {
		if (!name) {
			error = true
			errorMessage = 'please enter your name'
			return
		}
		const chckMail = validate('email', email)
		if (!chckMail) {
			error = true
			errorMessage = 'please enter a valid email-address'
			return
		}
		if (!message) {
			error = true
			errorMessage = 'please enter a message'
			return
		}

		sendMessage = true
		showSpinner = true
		const data = {
			receiver: 'admin',
			cmd: 'contact',
			sendername: name,
			mail: email,
			msg: message,
		}
		const sendMail = await send_mail('send_mail', data)

		if (sendMail) {
			showSpinner = false
			showResponse = true

			const toSend = setTimeout(() => {
				sendMessage = false
				email = null
				name = null
				message = null
				storeContact.set(false)
				clearTimeout(toSend)
			}, 5000)
		}
	}

	let showForm
	const stoContact = storeContact.subscribe((value) => {
		showForm = value
	})

	let email
	let name
	let message

	const show_form = () => {
		showForm = showForm === true ? false : true
		storeContact.set(showForm)
		animateScroll.scrollTo({ element: '#contact_title' })
	}

	const button_hover = (fc, bg) => {
		document.getElementById('send_button').style.backgroundColor = bg
		document.getElementById('send_button').style.color = fc
	}

	const close_alert = () => {
		error = false
	}

	onDestroy(() => {
		stoPreview
		stoData
		stoContact
	})
</script>

{#if configFile}
	{#if !showPreview}
		<div
			class="content_row"
			use:styles={{ fsS, builderToolbar, builderToolbarHover }}
			on:click={() => set_elementID('contact')}
			on:keydown={() => set_elementID('contact')}
		>
			<div style="margin-left:20px;">*OPEN CONTACT TOOL*</div>
		</div>
	{/if}
	{#each configFile.blocks as block}
		{#if block.blockName === 'contact'}
			<IntersectionObserver
				{element}
				threshold="0.5"
				on:observe={(e) => {
					if (!e.detail.isIntersecting) {
						set_observer('set')
					} else {
						set_observer('unset')
					}
				}}
			>
				<main id="contact" use:styles={{ height, padding, marginTop, marginBottom }} bind:this={element}>
					<div
						class="contact_outer"
						use:styles={{
							shadowX,
							shadowY,
							shadowBlur,
							shadowColor,
							borderTopRadius,
							borderBottomRadius,
							borderLeftWidth,
							borderLeftStyle,
							borderLeftColor,
							borderTopWidth,
							borderTopStyle,
							borderTopColor,
							borderRightWidth,
							borderRightStyle,
							borderRightColor,
							borderBottomWidth,
							borderBottomStyle,
							borderBottomColor,
						}}
					>
						<div
							id="contact_title"
							class="contact_title_container"
							on:click={show_form}
							on:keydown={show_form}
							use:styles={{
								titleAlign,
								titleValign,
								titleColor,
								titleBackgroundColor,
								titleFontFamily,
								titleFontSize,
								titleFontStyle,
								titleFontWeight,
								titleFontDeco,
								titleMT,
								titleMB,
								titleHeight,
								titlePadding,
								titleShadowX,
								titleShadowY,
								titleShadowBlur,
								titleShadowColor,
								shadowX,
								shadowY,
								shadowBlur,
								shadowColor,
							}}
						>
							{contactBlock.titleText}
						</div>
						{#if showForm}
							<div id="contactContainer" class="contact_container" transition:slide={{ duration: 1000 }}>
								<div
									class="container_left_content"
									use:styles={{
										containerLeftBg,
										containerLeftPaddingTop,
										containerLeftPaddingBottom,
									}}
								>
									{#if sendMessage}
										<div class="left_shader">
											{#if showSpinner}
												<Spinner fontSize={fsS} color="hsl(119,98%,50%)" size="50px" info="sending" />
											{/if}
											{#if showResponse}
												<div class="response" use:styles={{ fsS }}>Vielen Dank</div>
												<div class="response" use:styles={{ fsS }}>Wir haben Ihre Nachricht erhalten.</div>
												<div class="response" use:styles={{ fsS }}>
													Wenn nötig werden wir uns schnellst möglich melden.
												</div>
											{/if}
										</div>
									{/if}
									<input
										type="text"
										bind:value={name}
										placeholder="name"
										use:styles={{
											inputFontColor,
											inputFontFamily,
											inputFontSize,
											inputBorder,
											inputBg,
											inputShadowX,
											inputShadowY,
											inputShadowBlur,
											inputShadowColor,
											inputFocus,
										}}
									/>
									<input
										type="text"
										bind:value={email}
										placeholder="e-mail"
										use:styles={{
											inputFontColor,
											inputFontFamily,
											inputFontSize,
											inputBorder,
											inputBg,
											inputShadowX,
											inputShadowY,
											inputShadowBlur,
											inputShadowColor,
											inputFocus,
										}}
									/>
									<textarea
										bind:value={message}
										placeholder="message"
										use:styles={{
											inputFontColor,
											inputFontFamily,
											inputFontSize,
											inputBorder,
											inputBg,
											inputShadowX,
											inputShadowY,
											inputShadowBlur,
											inputShadowColor,
											inputFocus,
										}}
									/>
									<div class="button_container">
										<button
											id="send_button"
											on:click={send_form}
											on:mouseenter={() => button_hover(buttonFontHover, buttonHover)}
											on:mouseleave={() => button_hover(buttonFontColor, buttonBg)}
											use:styles={{
												buttonBg,
												buttonFontColor,
												buttonFontFamily,
												buttonFontSize,
												buttonBorderWidth,
												buttonBorderColor,
												buttonBorderRadius,
												inputShadowX,
												inputShadowY,
												inputShadowBlur,
												inputShadowColor,
											}}
										>
											{buttonText}</button
										>
									</div>
								</div>
								<div
									class="container_right_content"
									use:styles={{
										containerRightBg,
										containerLeftPaddingTop,
										containerLeftPaddingBottom,
									}}
								>
									<div class="info_container" use:styles={{ infoLeftBgColor }}>
										<div style="height:100%;">
											<div
												class="info_name"
												use:styles={{
													infoNameColor,
													infoNameFontSize,
													infoNameWeight,
													infoNameFontFamily,
													infoNameStyle,
													infoNameDeco,
													infoNameMarginBottom,
													infoLeftPadding,
												}}
											>
												{contactBlock.nameText}
											</div>
											<ul
												use:styles={{
													infoLeftPadding,
													infoAddressColor,
													infoAddressWeight,
													infoAddressStyle,
													infoAddressFontSize,
													infoAddressFontFamily,
													infoAddressMarginBottom,
												}}
											>
												<li>{contactBlock.streetText}</li>
												<li>{contactBlock.zipText} {contactBlock.cityText}</li>
												<li>{contactBlock.countryText}</li>
											</ul>
											<div
												class="contact_row"
												use:styles={{ infoContactFontSize, infoContactFontFamily, infoLeftPadding }}
											>
												<div
													class="contact_left"
													use:styles={{ infoContactLeftColor, infoContactLeftStyle, infoContactLeftWeight }}
												>
													phone:
												</div>

												<div
													class="contact_right"
													use:styles={{ infoContactRightColor, infoContactRightStyle, infoContactRightWeight }}
												>
													{contactBlock.phoneText}
												</div>
											</div>

											<div
												class="contact_row"
												use:styles={{ infoContactFontSize, infoContactFontFamily, infoLeftPadding }}
											>
												<div
													class="contact_left"
													use:styles={{ infoContactLeftColor, infoContactLeftStyle, infoContactLeftWeight }}
												>
													email:
												</div>

												<div
													class="contact_right"
													use:styles={{ infoContactRightColor, infoContactRightStyle, infoContactRightWeight }}
												>
													{contactBlock.emailText}
												</div>
											</div>
											<ContactMailList />
										</div>
									</div>
								</div>
								{#if contactBlock.map}
									<div class="map_container" use:styles={{ mapBgColor }}>
										<div
											id="map"
											class="map"
											use:styles={{
												mapHeight,
												mapWidth,
												mapBorderColor,
												mapBorderStyle,
												mapBorderWidth,
												mapShadowColor,
												mapShadowX,
												mapShadowY,
												mapShadowBlur,
											}}
										>
											<Map lat={contactBlock.mapLat} lng={contactBlock.mapLng} label={contactBlock.mapLabel} />
										</div>
									</div>
								{/if}
							</div>
						{/if}
					</div>
				</main>
			</IntersectionObserver>
		{/if}
	{/each}
{/if}

{#if error}
	<Shader>
		<div slot="content"><Alert message={errorMessage} showOkButton={false} on:alertclose={close_alert} /></div>
	</Shader>
{/if}

<style>
	main {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: var(--height);
		padding: var(--padding);
		margin-top: var(--marginTop);
		margin-bottom: var(--marginBottom);
	}
	.contact_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
	}
	input,
	textarea {
		outline: none;
		width: 90%;
		color: var(--inputFontColor);
		font-family: var(--inputFontFamily);
		font-size: var(--inputFontSize);
		border: 1px solid var(--inputBorder);
		background-color: var(--inputBg);
		box-shadow: var(--inputShadowX) var(--inputShadowY) var(--inputShadowBlur) var(--inputShadowColor);
	}

	input:focus,
	textarea:focus {
		background-color: var(--inputFocus);
	}

	textarea {
		height: clamp(150px, 18vw, 250px);
		resize: none;
	}

	ul {
		list-style-type: none;
		padding-left: var(--infoLeftPadding);
		color: var(--infoAddressColor);
		font-size: var(--infoAddressFontSize);
		margin-bottom: var(--infoAddressMarginBottom);
		font-weight: var(--infoAddressWeight);
		font-style: var(--infoAddressStyle);
		font-family: var(--infoAddressFontFamily);
	}

	button {
		background-color: var(--buttonBg);
		color: var(--buttonFontColor);
		font-family: var(--buttonFontFamily);
		font-size: var(--buttonFontSize);
		border: 1px solid var(--buttonBorderColor);
		border-radius: var(--buttonBorderRadius);
		box-shadow: var(--inputShadowX) var(--inputShadowY) var(--inputShadowBlur) var(--inputShadowColor);
		width: fit-content;
		height: fit-content;
		cursor: pointer;
	}

	.map_container {
		display: flex;
		align-items: center;
		justify-content: center;
		height: clamp(300px, 30vw, 470px);
		background-color: var(--mapBgColor);
	}

	.map {
		height: var(--mapHeight);
		width: var(--mapWidth);
		border: var(--mapBorderWidth) var(--mapBorderStyle) var(--mapBorderColor);
		box-shadow: var(--mapShadowX) var(--mapShadowY) var(--mapShadowBlur) var(--mapShadowColor);
	}

	.contact_outer {
		box-shadow: var(--shadowX) var(--shadowY) var(--shadowBlur) var(--shadowColor);
		border-top-left-radius: var(--borderTopRadius);
		border-top-left-radius: var(--borderTopRadius);
		border-top-right-radius: var(--borderTopRadius);
		border-bottom-left-radius: var(--borderBottomRadius);
		border-bottom-right-radius: var(--borderBottomRadius);
		border-left-width: var(--borderLeftWidth);
		border-left-style: var(--borderLeftStyle);
		border-left-color: var(--borderLeftColor);
		border-top-width: var(--borderTopWidth);
		border-top-style: var(--borderTopStyle);
		border-top-color: var(--borderTopColor);
		border-right-width: var(--borderRightWidth);
		border-right-style: var(--borderRightStyle);
		border-right-color: var(--borderRightColor);
		border-bottom-width: var(--borderBottomWidth);
		border-bottom-style: var(--borderBottomStyle);
		border-bottom-color: var(--borderBottomColor);
	}

	.contact_title_container {
		display: flex;
		justify-content: var(--titleAlign);
		align-items: var(--titleValign);
		width: 100%;
		height: var(--titleHeight);
		margin-top: var(--titleMT);
		margin-bottom: var(--titleMB);
		color: var(--titleColor);
		background-color: var(--titleBackgroundColor);
		font-family: var(--titleFontFamily);
		font-size: var(--titleFontSize);
		font-style: var(--titleFontStyle);
		font-weight: var(--titleFontWeight);
		text-decoration: var(--titleFontDeco);
		padding: var(--titlePadding);
		text-shadow: var(--titleShadowX) var(--titleShadowY) var(--titleShadowBlur) var(--titleShadowColor);
		cursor: pointer;
	}

	.container_left_content {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		height: clamp(300px, 30vw, 470px);
		background-color: var(--containerLeftBg);
		padding-top: var(--containerLeftPaddingTop);
		padding-bottom: var(--containerLeftPaddingBottom);
	}

	.left_shader {
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		top: 0px;
		left: 0px;
		height: clamp(300px, 30vw, 470px);
		width: 100%;
		z-index: 1;
		background-color: hsla(0, 0%, 0%, 0.7);
	}

	.response {
		color: hsl(119, 98%, 50%);
		font-size: var(--fsS);
	}

	.container_right_content {
		display: inline-block;
		height: clamp(300px, 30vw, 470px);
		background-color: var(--containerRightBg);
		padding-top: var(--containerLeftPaddingTop);
		padding-bottom: var(--containerLeftPaddingBottom);
	}

	.info_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		height: 100%;
		background-color: var(--infoLeftBgColor);
	}

	.info_name {
		color: var(--infoNameColor);
		font-size: var(--infoNameFontSize);
		font-weight: var(--infoNameWeight);
		font-family: var(--infoNameFontFamily);
		font-style: var(--infoNameStyle);
		text-decoration: var(--infoNameDeco);
		margin-bottom: var(--infoNameMarginBottom);
		padding-left: var(--infoLeftPadding);
	}

	.contact_row {
		display: grid;
		grid-template-columns: 20% 80%;
		font-size: var(--infoContactFontSize);
		font-family: var(--infoContactFontFamily);
		padding-left: var(--infoLeftPadding);
	}

	.contact_left {
		color: var(--infoContactLeftColor);
		font-style: var(--infoContactLeftStyle);
		font-weight: var(--infoContactLeftWeight);
	}

	.contact_right {
		color: var(--infoContactRightColor);
		font-style: var(--infoContactRightStyle);
		font-weight: var(--infoContactRightWeight);
	}

	.button_container {
		display: flex;
		width: 90%;
		justify-content: flex-end;
	}

	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}
</style>
